import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import RasterTileLayer from '@/components/map/mapbox-layers/RasterTileLayer.vue'
import { computed, ref, watch } from 'vue'
import { useGeneralStore } from '@/pinia'
import { Layer } from 'mapbox-gl'
import _ from 'lodash'


export default /*@__PURE__*/_defineComponent({
  __name: 'LayerWms',
  props: {
    layerId: {},
    before: {}
  },
  setup(__props: any) {



const piniaStore = useGeneralStore()

const filteredWmsLayers = computed(() => piniaStore.filteredWmsLayers)
const wmsSources = ref<{ type: string; tiles: string[] }[]>([])
async function generateGetMapUrl(wmsLayer) {
  /*
  Regarding Mapbox limitations:
  Mapbox supports the popular Web Mercator projection, commonly referred to as EPSG:900913 or EPSG:3857.
  As the documentation states, By providing a URL to a WMS server that supports EPSG:3857 (or EPSG:900913) as a source of tiled data.
  The server URL should contain a "{bbox-epsg-3857}" but the service doesn't support that CRS so you can't use it.
  You might be able to cascade through another WMS service, for example GeoServer and MapServer software can do this, or you could use MapProxy.
  */
  return `${
    wmsLayer.url
  }?service=WMS&version=1.1.1&request=GetMap&layers=${wmsLayer.sourceLayers.join()}&styles&srs=epsg:3857&bbox={bbox-epsg-3857}&width=512&height=512&format=image/png&transparent=true`
}
function layerWmsStyle(index: number): Layer {
  return {
    id: getWmsLayerId(index),
    source: getWmsSourceId(index),
    type: 'raster'
  }
}
function getWmsLayerId(index: number) {
  return `layer-wms-${index}`
}
function getWmsSourceId(index: number) {
  return `source-wms-${index}`
}

watch(
  () => _.cloneDeep(filteredWmsLayers.value),
  async (newWmss) => {
    wmsSources.value = []
    if (!newWmss.length || !newWmss.some((layer) => layer.visible)) return
    const visibleWmsLayers = newWmss.filter((layer) => layer.visible)
    const sources: { type: string; tiles: string[] }[] = []
    for (const layer of visibleWmsLayers) {
      const tileUrl = await generateGetMapUrl(layer)
      sources.push({
        type: 'raster',
        tiles: [tileUrl]
      })
    }
    wmsSources.value = sources
  }
)

return (_ctx: any,_cache: any) => {
  return (wmsSources.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wmsSources.value, (source, index) => {
          return (_openBlock(), _createBlock(RasterTileLayer, {
            key: index,
            before: _ctx.before,
            layer: layerWmsStyle(index),
            layerId: getWmsLayerId(index),
            sourceId: getWmsSourceId(index),
            source: source
          }, null, 8, ["before", "layer", "layerId", "sourceId", "source"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})